import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { FieldItem, FIELD_TYPES } from '../../widgets/fields'
import { CustomButton, showToaster, toasterTypes } from '../../widgets';
import ModalPopup from '../../widgets/modal';
import { set } from 'lodash';
import { DownloadOutlined } from '@ant-design/icons';
import { convertToIST } from '../../utils/ConvertUTCToLocale';
import { environment } from '../../environments/environment';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '../../store/slices/auth';
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { getVarConfig, saveVarConfig } from './apiController';
import { getRecord } from './apiController';

export default function PreviewForm(props) {
    const [isModify, setisModify] = useState(false);
    const [isPartialModify, SetisPartialModify] = useState(false);
    const [action, setAction] = useState("");
    const projectDataPerm = useSelector(authSelector)
    const [permissionData, setPermissionData] = useState<any>([]);
    const [layout, setLayout] = useState<any>([]);
    const [currentBreakpoint, setCurrentBreakpoint] = useState('lg');
    const [layoutFin, setLayoutFin] = useState<any>([]);
    const [recordData, setRecordData] = useState<any>([]);
    const [recordDataFields, setRecordDataFields] = useState<any>([]);

    const gridFields = ["radioButtonGrid", "checkBoxGrid", "textBoxGrid"];

    console.log(props)

    useEffect(() => {

        let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == props.projectData.id)
        let permArray = {};
        perData && perData[0]?.permissionData.forEach((obj) => {
            if (Object.keys(obj)[0] == "Data") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
                //setPermission(obj[Object.keys(obj)[0]])
            } else if (Object.keys(obj)[0] == "Forms") {
                obj[Object.keys(obj)[0]].forEach((objItem) => {
                    permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
                })
            }
        })
        console.log("TTTTTTTTTTTTTTt", perData, permArray)
        console.log(props)
        setPermissionData(permArray)
    }, [])

    function getValues(data) {
        let valuesData: any = [];
        data.forEach(element => {
            valuesData.push({
                label: element,
                value: element
            });
        });
        return valuesData;
    }

    const sendReviewApprove = (type) => {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

        let fieldsArray: Array<object> = [];
        Object.keys(props.variables || {}).map((obj, index) => {
            props.variables[obj].map((subObj, subIndex) => {
                //console.log(subObj)
                if (subObj.field_type === "dropDown" ||
                    subObj.field_type === "dropDownPreviousResponses") {
                    fieldsArray.push({
                        "id": subObj.id,
                        "field_selected_value": subObj?.selectedValue.label
                    })
                } else {
                    fieldsArray.push({
                        "id": subObj.id,
                        "field_selected_value": subObj?.selectedValue
                    })
                }

            })
        })


        let Obj = {
            "form_id": props.selectedRecord.form_id,
            "version_id": props.selectedRecord.version_id,
            "start_time": props.selectedRecord.start_time,
            "end_time": props.selectedRecord.end_time,
            "fields": fieldsArray,
            "update_remarks": "",
            "time_zone": tz,
            "id": props.selectedRecord.id
        };

        props.actions(type, Obj)
        setAction("")
    }

    /**
        * fetch form config data
        */
    const fetchConfig = async () => {
        try {
            let response = await getVarConfig(props.formData.id);
            console.log(response && response.data);
            let lay: any = [];

            Object.keys(props.variables || {}).map((obj, index) => {
                console.log(props.variables[obj])
                lay.push(props.variables[obj].map((subObj, subIndex) => {
                    let varSize = response.data && response.data.filter(flt =>
                        flt['var_id'] == subObj.id
                    )
                    if (varSize && varSize.length > 0) {
                        return {
                            c: obj,
                            i: subObj.id,
                            x: parseInt(varSize[0]?.var_x) || subIndex % 2, // 2 columns
                            y: parseInt(varSize[0]?.var_y) || Math.floor(subIndex / 2), // Row position
                            w: varSize[0]?.var_size,
                            h: parseInt(varSize[0]?.var_h) || 1
                        }
                    } else if(gridFields.includes(subObj.field_type)) {
                        let height = 3;
                        let width = 3
                        if(subObj.field_row_value && subObj.field_row_value.length > 0) {
                            if(subObj.field_row_value.length <= 4) {
                                height=3;
                                width=4;
                            }
                            else if(subObj.field_row_value.length > 4 && subObj.field_row_value.length <= 8) {
                                height=4;
                                width=4;
                            }else{
                                height=5;
                                width=4;
                            }
                            return {
                                c: obj,
                                i: subObj.id,
                                x: subIndex % 2, // 2 columns
                                y: Math.floor(subIndex / 2), // Row position
                                w: width,
                                h: height
                            }
                        }
                        else {
                            return {
                                c: obj,
                                i: subObj.id,
                                x: subIndex % 2, // 2 columns
                                y: Math.floor(subIndex / 2), // Row position
                                w: 4,
                                h: 3
                            }
                        }
                    }
                    
                    else {
                        return {
                            c: obj,
                            i: subObj.id,
                            x: subIndex % 2, // 2 columns
                            y: Math.floor(subIndex / 2), // Row position
                            w: 4,
                            h: 1
                        }
                    }
                }))
            })
            console.log(lay)
            setLayout(lay)
        } catch (error) {

        }
    }
    useEffect(() => {
        fetchConfig()
    }, [1])


    const handleLayoutChange = (layoutdata, layouts) => {
        console.log("--", layoutdata)
        let indexLayout = layout.findIndex(item => item[0]['i'] == layoutdata[0]['i'])
        console.log(indexLayout)
        layout.splice(indexLayout, 1, layoutdata)
        setLayoutFin(layout)

    }

    /**
     * save config
     */
    const SaveConfig = async () => {
        console.log("--", layoutFin)
        let finalArray: any = []
        layoutFin.map(item => {
            item.map(itm => {
                console.log(itm)
                let obj = {
                    var_id: itm.i,
                    var_size: itm.w,
                    var_x: itm.x,
                    var_y: itm.y,
                    var_h: itm.h
                }
                finalArray.push(obj)
            })
        })
        try {
            console.log(props)

            let response = await saveVarConfig(props.formData.id, finalArray)
            if (response) {
                showToaster(toasterTypes.SUCCESS, "Configurations saved")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const gridRef = useRef<HTMLDivElement | null>(null); // ✅ Correct TypeScript type

    // Function to calculate row height dynamically
    const getRowHeight = (): number => {
        if (!gridRef.current) return 100; // Default height
        return gridRef.current.offsetHeight / (layout.length / 2); // Adjust based on rows
    };

    const [rowHeight, setRowHeight] = useState<number>(getRowHeight());

    useEffect(() => {
        const handleResize = () => setRowHeight(getRowHeight());
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [layout]);

    return (
        <div className={window.innerWidth > 700 ? 'view-form' : 'view-form-mobile'}>
            {isModify && (
                <ModalPopup
                    modalType="delete"
                    modalText="Modify will allow you to modify previously entered data also."
                    actionText="Do you want continue modifying?"
                    closeModal={() => props.onClose()}
                    onAction={() => props.modify()}
                />
            )}

            {isPartialModify && (
                <ModalPopup
                    modalType="delete"
                    modalText="Modify Partial will allow you to update only empty fields only."
                    actionText="Do you want continue modifying?"
                    closeModal={() => props.onClose()}
                    onAction={() => props.partialModify()}
                />
            )}

            {action == "review" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to confirm the review."
                    actionText="Confrim Review?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("review")}
                />
            )}

            {action == "approve" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to approve this? Once approved, this action cannot be undone."
                    actionText="Confrim Approve?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("approve")}
                />
            )}

            {action == "rreview" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to revert the review."
                    actionText="Revert Review?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("rreview")}
                />
            )}

            {action == "rapprove" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to revert approval?"
                    actionText="Revert Approval?"
                    closeModal={() => props.onClose()}
                    onAction={() => sendReviewApprove("rapprove")}
                />
            )}

            <Row className='m-0'>
                <Col className='p-0'>
                    <div className='form-name'>{props.formData?.form_name}</div>
                </Col>

                <Col className='p-0 text-right'>
                    <i className='icon icon-close' onClick={() => props.onClose()} />
                </Col>
            </Row>
            <div className='form-scroll'>

                {Object.keys(props.variables || {}).map((obj, index) => (
                    <div key={index} >
                        <div className='category-container'>
                            <div className='category-text'>{obj !== 'empty' ? obj : ''}</div>
                        </div>
                        <div>
                            <div ref={gridRef}>
                                <GridLayout
                                    className="layout"
                                    layout={layout[index]}
                                    cols={4}
                                    rowHeight={200}
                                    width={window.innerWidth - 100}
                                    onBreakpointChange={setCurrentBreakpoint}
                                    onLayoutChange={handleLayoutChange}
                                    isDraggable={props.isPreview ? true : false}
                                    isResizable={props.isPreview ? true : false}>
                                    {props.variables[obj].map((subObj, subIndex) => (
                                        !subObj.is_time_series && !subObj.grid_grp_id && <div key={subObj.id}><div>
                                            <FieldItem
                                                name={subObj.id}
                                                placeholder={(subObj.field_type === 'number' || subObj.field_type === 'textBox' || subObj.field_type === 'textArea') ? 'Enter' : 'Select'}
                                                label={subObj.field_name}
                                                type={(subObj.field_type === 'fileUpload' || subObj.field_type === 'fileUploadOCR') ? FIELD_TYPES.TEXT : subObj.field_type === 'dateField' ? FIELD_TYPES.DATE_PICKER : subObj.field_type === 'dropDown' ? FIELD_TYPES.DROP_DOWN : subObj.field_type === 'boolean' ? FIELD_TYPES.BOOLEAN : subObj.field_type === 'radioButton' ? FIELD_TYPES.RADIO_BUTTON : subObj.field_type === 'checkBox' ? FIELD_TYPES.CHECK_BOX : subObj.field_type === 'textArea' ? FIELD_TYPES.TEXT_AREA : subObj.field_type === 'signatureCapture' ? FIELD_TYPES.SIGNATURE_CAPTURE : subObj.field_type === 'imageCapture' ? FIELD_TYPES.IMAGE_CAPTURE : subObj.field_type === 'videoCapture' ? FIELD_TYPES.VIDEO_CAPTURE : subObj.field_type === 'audioCapture' ? FIELD_TYPES.AUDIO_CAPTURE : subObj.field_type === "radioButtonGrid" ? FIELD_TYPES.RADIO_BUTTON_GRID
                                                    : subObj.field_type === "checkBoxGrid"
                                                        ? FIELD_TYPES.CHECK_BOX_GRID
                                                        : subObj.field_type === "textBoxGrid"
                                                            ? FIELD_TYPES.TEXT_BOX_GRID
                                                            : FIELD_TYPES.TEXT}
                                                value={props.isPreview ? '' : subObj.field_type === "dateTime" ? convertToIST(subObj.selectedValue) : subObj.selectedValue}
                                                values={gridFields.includes(subObj.field_type) ? subObj.field_value : getValues(subObj.field_value || [])}
                                                rowValues={gridFields.includes(subObj.field_type) ? subObj.field_row_value : []}
                                                isListed={true}
                                                isDisabled={true}
                                                isPreview={(subObj.field_type === 'signatureCapture' || subObj.field_type === 'imageCapture' || subObj.field_type === 'audioCapture' || subObj.field_type === 'videoCapture') ? true : false}
                                            />

                                            {/* {subObj.field_type === 'fileUpload' ?
                                            <div style={{ marginTop: "18%", marginRight: "30px" }}><a href={environment.imageBaseUrl + subObj.selectedValue} download><DownloadOutlined style={{ fontSize: "20px" }} /></a></div>
                                            : ""
                                        }
                                    */}
                                            {/* <div className="drag-handle">⠿</div> */}

                                        </div>

                                        </div>
                                    ))}
                                </GridLayout>
                            </div>
                            <GridLayout
                                className="layout"
                                layout={layout[index]}
                                cols={4}
                                rowHeight={150}
                                width={window.innerWidth - 100}
                                onBreakpointChange={setCurrentBreakpoint}
                                onLayoutChange={handleLayoutChange}
                                isDraggable={props.isPreview ? true : false}
                                isResizable={props.isPreview ? true : false}>
                                {props.variables[obj].map((subObj, subIndex) => (
                                    subObj.is_time_series && <div key={subIndex}>
                                        <FieldItem
                                            name={subObj.id}
                                            placeholder={(subObj.field_type === 'number' || subObj.field_type === 'number' || subObj.field_type === 'textArea') ? 'Enter' : 'Select'}
                                            label={subObj.field_name}
                                            labelIcon="icon-loop"
                                            type={subObj.field_type === 'dateField' ? FIELD_TYPES.DATE_PICKER : subObj.field_type === 'dropDown' ? FIELD_TYPES.DROP_DOWN : subObj.field_type === 'boolean' ? FIELD_TYPES.BOOLEAN : subObj.field_type === 'radioButton' ? FIELD_TYPES.RADIO_BUTTON : subObj.field_type === 'checkBox' ? FIELD_TYPES.CHECK_BOX : subObj.field_type === 'textArea' ? FIELD_TYPES.TEXT_AREA : FIELD_TYPES.TEXT}
                                            value={props.isPreview ? '' : subObj.field_type === "dateTime" ? convertToIST(subObj.selectedValue) : subObj.selectedValue}
                                            values={getValues(subObj.field_value || [])}
                                            isListed={true}
                                            isDisabled={true}
                                        />

                                    </div>
                                ))}
                            </GridLayout>
                        </div>
                    </div>
                ))}
            </div>
            {
                !props.isPreview ?
                    <div className="modify-footer-form">


                        {
                            permissionData && permissionData['edit partial data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Modify Partial"
                                    onClick={() => SetisPartialModify(true)}
                                />
                                : ""
                        }

                        {
                            permissionData && permissionData['edit record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Modify"
                                    onClick={() => setisModify(true)}
                                />
                                : ""
                        }

                        {
                            permissionData && permissionData['review data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Confirm Review"
                                    onClick={() => setAction("review")}
                                />
                                :
                                ""
                        }

                        {
                            permissionData && permissionData['reverse review data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Revert Review"
                                    onClick={() => setAction("rreview")}
                                />
                                :
                                ""
                        }

                        {
                            permissionData && permissionData['approve data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Confirm Approval"
                                    onClick={() => setAction("approve")}
                                />
                                :
                                ""
                        }


                        {
                            permissionData && permissionData['reverse approval data record'] || Object.keys(permissionData).length == 0 ?
                                <CustomButton
                                    type="primary"
                                    text="Revert Approval"
                                    onClick={() => setAction("rapprove")}
                                />
                                : ""
                        }



                    </div>
                    :
                    <div className="modify-footer-form">
                        <CustomButton
                            type="primary"
                            text="Save Config"
                            onClick={() => SaveConfig()}
                        />
                    </div>
            }


        </div >
    )
}
